/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    BottleShortDto,
    BottleSizeDto,
    BottleSummaryBasicDto,
    BottleSummaryDto,
    BottleSummaryExtendedDto,
    TagStatusDto,
    WineBottleBlockchainReportDto,
    WineBottleSearchParamsDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class BottleControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        changeBottleStatus(
                    id: number,
                    status: string
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/${id}/status/${status}`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        checkIsBottleAvailable(
                    tid: string
    ): Observable<TagStatusDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/${tid}/box/available`;

            return this._httpClient.get<TagStatusDto>(url, requestOptions);
    }


        getAvailableBottles(
                
                queryParams: {
                    wineProductInstanceId: number
                }
    ): Observable<Array<BottleSizeDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/available`;

            return this._httpClient.get<Array<BottleSizeDto>>(url, requestOptions);
    }


        getBottle(
                    id: number
    ): Observable<BottleShortDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/${id}`;

            return this._httpClient.get<BottleShortDto>(url, requestOptions);
    }


        getBottleBlockchainHistory(
                    id: number
    ): Observable<WineBottleBlockchainReportDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/${id}/history/blockchain`;

            return this._httpClient.get<WineBottleBlockchainReportDto>(url, requestOptions);
    }


        getBottleSummary(
                    id: number
    ): Observable<BottleSummaryDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/${id}/bottleSummary`;

            return this._httpClient.get<BottleSummaryDto>(url, requestOptions);
    }


        getBottleSummaryBasic(
                    id: number
    ): Observable<BottleSummaryBasicDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/${id}/bottleSummary/basic`;

            return this._httpClient.get<BottleSummaryBasicDto>(url, requestOptions);
    }


        getBottleSummaryExtended(
                    id: number
    ): Observable<BottleSummaryExtendedDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/${id}/bottleSummary/extended`;

            return this._httpClient.get<BottleSummaryExtendedDto>(url, requestOptions);
    }


        getBottlesBySearchParams(
                    
                    
                    requestBody: WineBottleSearchParamsDto
    ): Observable<Array<BottleShortDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottle/search`;

            return this._httpClient.post<Array<BottleShortDto>>(url, requestBody, requestOptions);
    }


        getRandomBottle(
    ): Observable<BottleShortDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/random`;

            return this._httpClient.get<BottleShortDto>(url, requestOptions);
    }


        getRecentBottles(
    ): Observable<Array<BottleShortDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/recent`;

            return this._httpClient.get<Array<BottleShortDto>>(url, requestOptions);
    }


        searchSingleBottle(
                
                queryParams: {
                    tid: string
                }
    ): Observable<BottleShortDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottle/searchOne`;

            return this._httpClient.get<BottleShortDto>(url, requestOptions);
    }


}

